import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import mmt from 'moment';
import { listenForPrivateEvent, joinPresenceChannel } from '../plugins/pusher';
import permissions from './modules/permissions';
import auth from './modules/auth';
import app from './modules/app';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        shiftId:0,
        removeOrderShift:0,
        activeUsers: [],
        currentUser: JSON.parse(localStorage.getItem('current_user')) || null,
        token: localStorage.getItem('access_token') || null,
        roles: localStorage.getItem('roles') || null,
        idrol: localStorage.getItem('rol') || null,
        dialog: false,
        delete: false,
        deleteBack: false,
        oocompanies: {
            add: false
        },
        audit: {
            show: false
        },
        concil: {
            customerSelection: false,
            genericReport: false,
            matchedDataPanel: false,
            bolDetails: false,
            reports: {
                InvoiceSummary: false,
                OutstandingBOLs: false,
                StmtUpByClearingDoc: false,
                StmtSumByDateRange: false,
                InvSumByDateRange: false,
                StmtSumRepByStmt: false
            }
        },
        CircleK: {
            Match: false,
            Stmt: false,
            InvSum: false,
            Ucd: false,
            StmtRange: false,
            StmtRangeInvoice: false
        },
        Suncor: {
            Match: false,
            Stmt: false,
            InvSum: false,
            Ucd: false,
            StmtRange: false,
            StmtRangeInvoice: false,
            Drilldown: false
        },
        Parkland: {
            Match: false,
            Stmt: false,
            InvSum: false,
            Ucd: false,
            StmtRange: false,
            StmtRangeInvoice: false,
            Drilldown: false
        },
        bannerType: false,
        marker: true,
        driverHrly: {
            posting: false
        },
        markerDT: true,
        placeholder: 'YYYY-MM-DD',
        mask: '####-##-##',

        placeholderDT: 'MM-DD HH:MM',
        maskDT: '##-## ##:##',
        scoreCard: {
            allDialog: false
        },
        timeRules: [
            v => parseInt(v[0] + v[1]) <= 23 || 'Time Incorrect',
            v => parseInt(v[3] + v[4]) <= 59 || 'Time Incorrect',
            v => parseInt(v[6] + v[7]) <= 59 || 'Time Incorrect'
        ],
        orderType: {
            dialog: false
        },
        noLoadType: {
            dialog: false
        },
        fuel: {
            entries: [],
            check: false
        },
        fuelStatement: [],
        dateRules: [],
        dateTimeRules: [],
        mini: false,
        editedOrder: {
            id: null,
            destiny: null,
            StationID: null
        },
        invoiceKms: {
            search: null,
            kagCostco: false
        },
        groupFSC: {
            rename: false,
            add: false,
            history: false
        },
        productCode: {
            create: false,
            watch: false,
            edit: false
        },
        invoiceLoadId: 0,
        invoiceParams: [],
        editedCustomer: {
            id: 0
        },
        newTransact: {
            go: 0,
            revenue: true,
            payroll: true,
            NotPost: false,
            exceptionRev: false,
            exceptionPay: false,
            transacting: false,
            NoRate: false,
            all: true,
            loads: false
        },

        assignment: {
            truckDisabled: false,
            dialog: false,
            new: false
        },
        undefined: {
            create: false,
            edit: false,
            watch: false
        },
        CredentialType: {
            create: false,
            edit: false,
            watch: false
        },
        BadgeCred: {
            watch: false
        },
        invoice: {
            dialogOrder: false,
            excel: false
        },
        book: {
            dialog: false
        },
        readings: {
            dialog: false,
            multiple: false
        },
        order: {
            add: false,
            edt: false,
            rdnAdd: false,
            view: false,
            type: ''
        },
        customerRate: {
            add: false
        },
        stationRate: {
            watch: false
        },
        editedYard: {
            id: 0
        },
        editedAction: {
            id: 0
        },
        editedTrailer: {
            id: 0
        },
        editedDriver: {
            id: 0
        },
        editedProduct: {
            id: 0
        },
        editedStation: {
            id: 0
        },
        editedTerminal: {
            id: 0
        },
        editedSupplier: {
            id: 0
        },
        editedTruck: {
            id: 0
        },
        editedTank: {
            id: 0
        },
        report: {
            preventive: false
        },
        siteReadings: {
            SiteNum: 0,
            dialog: false
        },
        orderInfo: {
            orderId: 0,
            shiftDetail: 0
        },
        posting: {
            rdDialogTracking: false,
            dialog: false,
            mod: false,
            watch: false
        },
        credential: {
            dialog: false
        },
        badge: {
            dialog: false
        },
        regular: {
            watch: false
        },
        regularPayroll: {
            watch: false
        },
        demurrage: {
            dialog: false,
            edit: false,
            delete: false,
            watch: false
        },
        payroll: {
            searchInv: '',
            modalUncharged: false,
            dialog: false,
            StartDate: null,
            EndDate: null,
            orders: [],
            watch: false,
            statementRp: false,
            ifta: false,
            entries: false
        },
        analytics: {
            StartTime: '',
            EndTime: '',
            url: '',
            subTitle: '',
            truckCost: '',
            title: '',
            itm: null,
            Yard: null,
            subItem: null,
            specific: '',
            posting: null,
            RollingDate: null
        },
        load: {
            StartTime: '',
            EndTime: '',
            url: '',
            subTitle: '',
            title: '',
            itm: null,
            Yard: null,
            subItem: null,
            specific: ''
        },
        ckedi: {
            openFuelFreight: false,
            openFileSendingPanel: false
        },
        dispatch: {
            qualifications: false,
            canvas: false,
            trailerID: '',
            shift: '',
            advice: false,
            adviceWatch: false,
            edtAdvice: false,
            adviceDlg: false,
            mail: false,
            potoshift: false,
            lastETA: false,
            shiftSummary: false,
            processVerifier: false,
            finalizeCurrentOrderInProgress: false,
            unknownOrigins: false,
            syncWarning: false,
            confirmWindow: false,
            productCompartments: false
        },
        paperworkAnalytics: {
            action: false,
            DailySummay: false,
            showOrderDataViewer: false,
            showPaperworkAnalyticsPanel: false,
            PpwEmail: false
        },
        accounting: {
            addExtExpense: false
        },
        transacting: {
            dialogAddExt: false,
            dialogRate: false,
            watch: false,
            watchMargin: false,
            start_date: '',
            end_date: '',
            return: '',
            itm: null,
            unfinalizedCause: false,
            Normaldialog: false,
            marginComment: false
        },
        privateStations: {
            addStation: false,
            addProduct: false,
            watch: false
        },
        CKDroppedList: {
            shiftId: 0
        },
        TrackingHrs: {
            shiftId: 0
        },
        tracking: {
            editProduct: false,
            watch: null,
            pendings: false,
            CKDroppedList: false,
            TrackingHrs: false,
            TrackingDiff: false,
            totalDrop: false
        },
        expensesEntries: {
            start_date: '',
            end_date: ''
        },
        checkStatements: {
            start_date: '',
            end_date: ''
        },
        viewFuelStatements: {
            from: ''
        },
        viewFuelStatementsSuppInvNo: {
            suppInvNo: ''
        },
        eleos: {
            demurrage: false,
            pending: false
        },
        searchFuelExpenseDetails: {
            searchParameter: {},
            searchValue: ''
        },
        // url: 'http://upt.la:8000/api/',
        // url: 'http://upt.net:8000/api/',
        //  urlPdf:'http://upt.net:8000/',
        // url: 'http://35.172.84.214/api/',
        snackbar: {},
        isLoading: false,
        changeIcon() {
            this.iconIndex === this.icons.length - 1
                ? (this.iconIndex = 0)
                : this.iconIndex++;
        },
        getMsk(id) {
            return document.getElementById(id).value;
        },
        getFormat(date) {
            if (this.marker == true) {
                return mmt().format('YYYY') + '-' + date;
            } else {
                return date;
            }
        }
    },
    getters: {
        loggedIn(state) {
            return state.token !== null;
        },
        getActiveUsers: state => state.activeUsers,
        getCurrentUser: (state) => state.currentUser,
    },
    mutations: {
        SET_SNACKBAR(state, snackbar) {
            state.snackbar = snackbar;
        },
        SET_DIALOG(state, dialog) {
            state.dialog = dialog;
        },
        retrieveToken(state, token) {
            state.token = token;
        },
        retrivePermissions(state, permissions) {
            state.permissions = permissions;
        },
        retriveRoles(state, roles) {
            state.roles = roles;
        },
        destroyToken(state) {
            state.token = null;
        },
        destroyRoles(state) {
            state.roles = null;
        },
        destroyPermissions(state) {
            state.permissions = null;
        },
        SET_CURRENT_USER(state, user) {
            state.currentUser = user;
        }
    },

    actions: {
        setupPusherEventListener({ rootGetters, dispatch }) {
            const permissions = rootGetters['permissions/getPermissions'];
            if (permissions.length === 0) {
                console.log('Permissions not loaded yet, retrying...');
                // If permissions are not loaded, try to load them and then retry
                return dispatch(
                    'permissions/loadUserRolesAndPermissions',
                    null,
                    { root: true }
                ).then(() =>
                    dispatch('setupPusherEventListener', null, { root: true })
                );
            }

            if (rootGetters['permissions/hasPermission']('channel.it')) {
                listenForPrivateEvent('it-channel', 'request', e => {
                    console.log('Received it-event:', e);
                });
            } else {
                console.log('User does not have permission for channel.it');
            }

            joinPresenceChannel('active-users', {
                here: users => {
                    console.log('Present users:', users);
                    this.state.activeUsers = users;
                },
                joining: user => {
                    console.log('User joined:', user);
                    this.state.activeUsers.push(user);
                },
                leaving: user => {
                    console.log('User left:', user);
                    this.state.activeUsers = this.state.activeUsers.filter(
                        u => u.id !== user.id
                    );
                },
                updated: event => {
                    console.log('User status updated:', event);
                    // Update user status in activeUsers
                }
            });
        },
        setSnackbar({ commit }, snackbar) {
            snackbar.show = true;
            commit('SET_SNACKBAR', snackbar);
        },
        setDialog({ commit }, dialog) {
            commit('SET_DIALOG', dialog);
            dialog.show = true;
        },
        toggleMarkerDT() {
            this.state.markerDT = !this.state.markerDT;
            if (this.state.maskDT == '##-## ##:##') {
                this.state.placeholderDT = 'YYYY-MM-DD MM:DD';
                this.state.maskDT = '####-##-## ##:##';
                this.state.dateTimeRules = [
                    v => !!v || 'This DateTime is required',
                    v =>
                        (parseInt(v[5] + v[6]) <= 12 &&
                            parseInt(v[5] + v[6]) > 0) ||
                        'Date Incorrect',
                    v =>
                        (parseInt(v[8] + v[9]) <= 31 &&
                            parseInt(v[8] + v[9]) > 0) ||
                        'Date Incorrect',
                    v => parseInt(v[11] + v[12]) <= 23 || 'Time Incorrect',
                    v => parseInt(v[14] + v[15]) <= 59 || 'Time Incorrect'
                ];
            } else {
                this.state.maskDT = '##-## ##:##';
                this.state.placeholderDT = 'MM-DD HH:MM';
                this.state.dateTimeRules = [
                    v => !!v || 'This DateTime is required',
                    v =>
                        (parseInt(v[0] + v[1]) <= 12 &&
                            parseInt(v[0] + v[1]) > 0) ||
                        'Date Incorrect',
                    v =>
                        (parseInt(v[3] + v[4]) <= 31 &&
                            parseInt(v[3] + v[4]) > 0) ||
                        'Date Incorrect',
                    v => parseInt(v[6] + v[7]) <= 23 || 'Time Incorrect',
                    v => parseInt(v[9] + v[10]) <= 59 || 'Time Incorrect'
                ];
            }
        },
        toggleMarker() {
            this.state.marker = !this.state.marker;
            if (this.state.mask == '##-##') {
                this.state.placeholder = 'YYYY-MM-DD';
                this.state.mask = '####-##-##';
                this.state.dateRules = [
                    v =>
                        (parseInt(v[5] + v[6]) <= 12 &&
                            parseInt(v[5] + v[6]) > 0) ||
                        'Date Incorrect',
                    v =>
                        (parseInt(v[8] + v[9]) <= 31 &&
                            parseInt(v[8] + v[9]) > 0) ||
                        'Date Incorrect'
                ];
            } else {
                this.state.mask = '##-##';
                this.state.placeholder = 'MM-DD';
                this.state.dateRules = [
                    v => !!v || 'This date is required',
                    v =>
                        (parseInt(v[0] + v[1]) <= 12 &&
                            parseInt(v[0] + v[1]) > 0) ||
                        'Date Incorrect',
                    v =>
                        (parseInt(v[3] + v[4]) <= 31 &&
                            parseInt(v[3] + v[4]) > 0) ||
                        'Date Incorrect'
                ];
            }
        },
        retrieveToken(context, credentials) {
            return new Promise((resolve, reject) => {
                Axios.post('login', {
                    username: credentials.username,
                    password: credentials.password
                })
                    .then(response => {
                        //console.log(response)
                        const token = response.data.token;
                        if (credentials.remember) {
                            localStorage.setItem('access_token', token);
                            localStorage.setItem('roles', response.data.role);
                            localStorage.setItem(
                                'permissions',
                                JSON.stringify(response.data.permissions)
                            );
                        } else {
                            sessionStorage.setItem('access_token', token);
                            sessionStorage.setItem('roles', response.data.role);
                            sessionStorage.setItem(
                                'permissions',
                                JSON.stringify(response.data.permissions)
                            );
                        }
                        context.commit('retrieveToken', token);
                        context.commit('retriveRoles', response.data.role);
                        context.commit(
                            'retrivePermissions',
                            response.data.permissions
                        );
                        Axios.defaults.headers.common['Authorization'] = token
                            ? 'Bearer ' + token
                            : null;
                        resolve(response);
                    })
                    .catch(error => {
                        //console.log(error)
                        reject(error);
                    });
            });
        },
        destroyToken(context) {
            if (context.getters.loggedIn) {
                return new Promise((resolve, reject) => {
                    Axios.post('/logout', '', {
                        headers: {
                            Authorization: 'Bearer ' + context.state.token
                        }
                    })
                        .then(response => {
                            //console.log(response)
                            localStorage.removeItem('access_token');
                            context.commit('destroyToken');
                            localStorage.removeItem('roles');
                            context.commit('destroyRoles');
                            localStorage.removeItem('permissions');
                            context.commit('destroyPermissions');
                            resolve(response);
                        })
                        .catch(error => {
                            //console.log(error)
                            localStorage.removeItem('access_token');
                            context.commit('destroyToken');

                            reject(error);
                        });
                });
            }
        },
        setCurrentUser({ commit }, user) {
            commit('SET_CURRENT_USER', user);
        }
    },
    modules: {
        permissions,
        auth,
        app
    }
});
